import Checkbox from "./checkbox.vue";
import Radio from "./radio.vue";
import uiRadioEl from "./uiRadio.vue";
import UiCheckboxEl from "./uiCheckbox.vue";
import UiFlexTextarea from "./uiFlexTextarea.vue";
import UiActionsMenu from "./uiActionsMenu.vue";
import HasElipsis from './HasElipsis.vue';
// import UiSelectList from "./uiSelectList.vue";
import uiMoreButton from "./uiMoreButton.vue";
import uiDropdownEl from "./uiDropdown.vue";
import SubTitle from "./subTitle.vue";
import SpinnerBtn from "./spinnerBtn.vue";
import uiLoadingData from "./uiLoadingData.vue";
import TrueFalse from "./TrueFalse.vue";

const Elements = {
  install(Vue, options) {
    Vue.component("HasElipsis", HasElipsis);
    Vue.component("SpinnerBtn", SpinnerBtn);
    Vue.component("Checkbox", Checkbox);
    Vue.component("Radio", Radio);
    Vue.component("uiRadioEl", uiRadioEl);
    Vue.component("UiCheckboxEl", UiCheckboxEl);
    Vue.component("UiLoadingData", uiLoadingData);
    Vue.component("UiFlexTextarea", UiFlexTextarea);
    Vue.component("uiMoreButton", uiMoreButton);
    Vue.component("uiDropdownEl", uiDropdownEl);
    // Vue.component("UiSelectList", UiSelectList);
    Vue.component("UiActionsMenu", UiActionsMenu);
    Vue.component("SubTitle", SubTitle);
    Vue.component("TrueFalse", TrueFalse);
  }
};

export default Elements;



// WEBPACK FOOTER //
// ./src/components/ui/UiElements.js